<template>
  <div class="card" :class="`${withShadow ? 'card--shadow' : '' }`">
    <slot/>
  </div>
</template>

<script>
export default {
  props: {
    withShadow: { type: Boolean, required: false, default: false },
  },
};
</script>

<style lang="stylus" scoped>
.card {
  border: 1px solid #d7dded;
  border-radius: 6px;
  padding: 16px 32px 24px;
  background: #fff;
}

.card--shadow {
  box-shadow: 0px 1px 3px rgba(0,0,0, 0.1);
}
</style>
